import React, {Component} from 'react';
import logo from '../../../../images/logo-big.jpg';
import './styles.css';
import {NavLink} from 'react-router-dom';


export default class Home extends Component {

    render(){
        return(
            <div className="Home container-fluid">
                <div>
                    <img src={logo} alt='AMCEMIG' />
                    <br/>
                    <NavLink to='/members'><h4>Ir al listado de miembros</h4></NavLink>

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Home/index.jsx